import NavActions from './nav-actions';
import { reduxActions } from '../constants';

export default class RouteActions {
    static setAppState(route) {
        return dispatch => {
            dispatch(RouteActions.changeState(route));
            dispatch(NavActions.menuToggle(false));
        }
    }

    static changeState(route) {
        return {
            type: reduxActions.STATE_CHANGE,
            route: route
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/route-actions.js